import { useEffect, useRef, useState } from "react";

const AD_CLIENT = "ca-pub-4816249160383573";
const MAX_INIT_ATTEMPTS = 40;
const RETRY_DELAY_MS = 250;

const AdSenseUnit = ({ slot, className = "", style = {} }) => {
  const adRef = useRef(null);
  const [isFilled, setIsFilled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !slot || !adRef.current) return undefined;

    let attempts = 0;
    let timeoutId = null;
    let observer = null;

    setIsFilled(false);

    const syncAdStatus = () => {
      const adElement = adRef.current;
      if (!adElement) return;
      setIsFilled(adElement.getAttribute("data-ad-status") === "filled");
    };

    const tryInitializeAd = () => {
      const adElement = adRef.current;
      if (!adElement) return;
      const status = adElement.getAttribute("data-ad-status");
      if (status) {
        syncAdStatus();
        return;
      }

      if (!window.adsbygoogle) {
        if (attempts >= MAX_INIT_ATTEMPTS) return;
        attempts += 1;
        timeoutId = window.setTimeout(tryInitializeAd, RETRY_DELAY_MS);
        return;
      }

      try {
        window.adsbygoogle.push({});
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.warn(`AdSense push failed for slot ${slot}.`, error);
        }
      }
    };

    observer = new MutationObserver(syncAdStatus);
    observer.observe(adRef.current, {
      attributes: true,
      attributeFilter: ["data-ad-status"],
    });

    syncAdStatus();
    tryInitializeAd();

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
      if (observer) {
        observer.disconnect();
      }
    };
  }, [slot]);

  if (!slot) return null;

  const visibleStyle = {
    width: "100%",
    maxWidth: "1100px",
    margin: "24px auto",
    padding: "0 16px",
    ...style,
  };

  const hiddenStyle = {
    ...visibleStyle,
    margin: "0 auto",
    padding: "0",
    height: "0",
    minHeight: "0",
    overflow: "hidden",
  };

  return (
    <div
      className={className}
      style={isFilled ? visibleStyle : hiddenStyle}
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSenseUnit;
